import { IDataProviderFilter, Logic, Operator } from 'core-components/types'

import { EGlobalPartnerFilterOptions } from '../configs'

interface IGetFilterByData {
  globalPartnerType: string
  currentFYear: number
  searchValue?: string
  globalPartnerFilter?: EGlobalPartnerFilterOptions
}

export const getFilterByData = ({
  globalPartnerType,
  currentFYear,
  searchValue,
  globalPartnerFilter,
}: IGetFilterByData): IDataProviderFilter => {
  const isHqPartnerFilter = globalPartnerFilter == EGlobalPartnerFilterOptions.Synced
  const isItsPartnerFilter = globalPartnerFilter == EGlobalPartnerFilterOptions.ITS

  const filters = [
    {
      field: 'RTM',
      operator: Operator.EQUAL,
      value: globalPartnerType,
    },
    {
      field: 'FYear',
      operator: Operator.EQUAL,
      value: currentFYear,
    },
    {
      field: 'SearchParam',
      operator: Operator.EQUAL,
      value: searchValue || null,
    },
    {
      field: 'isHQPartnerId',
      operator: Operator.EQUAL,
      value: isHqPartnerFilter ? 1 : null,
    },
    {
      field: 'IsITS',
      operator: Operator.EQUAL,
      value: isItsPartnerFilter ? 1 : null,
    },
  ]

  return {
    logic: Logic.AND,
    filters,
  }
}
